import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { fetchProductVariantsMatrix } from 'b2b-apps/shop/product/redux/productVariantsMatrix/actionCreators';
import { getProductVariantsMatrixBySku } from 'b2b-apps/shop/product/redux/productVariantsMatrix/selectors';
import { ProductVariantsMatrixType } from 'b2b-apps/shop/product/redux/productVariantsMatrix/types';

type UseProductVariantsMatrixEffectReturnType = RemoteRecord<ProductVariantsMatrixType>;

const useProductVariantsMatrixEffect = (
  sku: string,
): UseProductVariantsMatrixEffectReturnType => {
  const dispatch = useDispatch();
  const variantsMatrix = useSelector(state => getProductVariantsMatrixBySku(state, sku));

  useEffect((): void => {
    if (!variantsMatrix.wasStarted) {
      dispatch(fetchProductVariantsMatrix(sku));
    }
  }, [variantsMatrix.wasStarted, dispatch, sku]);

  return variantsMatrix;
};

export { useProductVariantsMatrixEffect };
export type { UseProductVariantsMatrixEffectReturnType };
